<template>
  <el-dialog :model-value="show"
             class="cus-el-dialog"
             :width="765"
             :before-close="handleClose">
    <div class="dialog-content">
      <p class="font18 italic-bold text-center">Review</p>
      <div class="line" />
      <div class="pd-t-20">
        <div class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('ACCT') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              {{ reviewInfo.chartererAcctCorp?.label }}
            </div>
          </div>
        </div>
        <div class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('DWT Required') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <template v-if="reviewInfo?.dwtRequirement.vesselTypes">
                {{ reviewInfo.dwtRequirement.vesselTypesLables.split(',').join(' / ') }}
              </template>
              <template v-if="reviewInfo?.dwtRequirement.kiloMin && reviewInfo?.dwtRequirement.kiloMax ">
                {{ reviewInfo?.dwtRequirement.kiloMin }}K - {{ reviewInfo?.dwtRequirement.kiloMax }}K MT
              </template>
              <template v-if="reviewInfo?.dwtRequirement.dwtMin && reviewInfo?.dwtRequirement.dwtMax ">
                {{ reviewInfo?.dwtRequirement.dwtMin }} - {{ reviewInfo?.dwtRequirement.dwtMax }} MT
              </template>
            </div>
          </div>
        </div>
        <div class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('VIA') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <template v-if="reviewInfo.viaPortLoadLabels ||reviewInfo?.viaPortDischargeLabels">
                {{ reviewInfo.viaPortLoadLabels ? reviewInfo.viaPortLoadLabels : '-' }}
                <template v-if="reviewInfo?.viaPortDischargeLabels">
                  / {{ reviewInfo?.viaPortDischargeLabels  }}
                </template>
              </template>

            </div>
          </div>
        </div>
        <div class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('Delivery Port') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <div class="flex-al-start flex-jc-bt">
                <div style="width: auto;padding-right: 40px">
                  {{ reviewInfo.delyTag }}
                </div>
                <div class="flex-1">
                  {{ [...new Set(reviewInfo.loadingPort.map(item => item.label))].join(' / ') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="reviewInfo?.firstPortLabels || reviewInfo?.lastPortLabels" class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('VIA L/D Port') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <span v-if="reviewInfo?.firstPortLabels">{{ reviewInfo.firstPortLabels.split(',').join(' / ') }}</span>
              <span v-if="reviewInfo?.firstPortLabels && reviewInfo?.lastPortLabels">&nbsp;-&nbsp;</span>
              <span v-if="reviewInfo?.lastPortLabels">{{ reviewInfo.lastPortLabels.split(',').join(' / ') }}</span>
            </div>
          </div>
        </div>

        <div class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('Redelivery Port') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <div class="flex-al-start flex-jc-bt">
                <div style="width: auto;padding-right: 40px">
                  {{ reviewInfo.redelTag }}
                </div>
                <div class="flex-1">
                  <!--                  {{ reviewInfo.dischargingPort }} -->
                  {{ [...new Set(reviewInfo.dischargingPort.map(item => item.label))].join(' / ') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('Laycan') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <span v-html="formatDateSection(cargoOrders.earliestLaycan, cargoOrders.latestLaycan, ' - ')" />
            </div>
          </div>
        </div>
        <div v-if="reviewInfo?.periodAbout || (reviewInfo.periodFrom && reviewInfo.periodTo) || (reviewInfo.llMin && reviewInfo.llMax)" class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('Duration') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <span v-if="reviewInfo?.periodAbout">
                About <span style="margin: 0 2px">{{ reviewInfo?.periodAbout }}</span>Days &nbsp;&nbsp;&nbsp;
              </span>
              <span v-if="reviewInfo?.periodFrom && reviewInfo?.periodTo">
                {{ reviewInfo?.periodFrom }}-{{ reviewInfo?.periodTo }} <span style="margin-left: 2px">Days</span> &nbsp;&nbsp;&nbsp;
              </span>
              <span v-if="reviewInfo.llMin || reviewInfo.llMax">
                With {{ reviewInfo.llMin || reviewInfo.llMax }}
                <span v-if="reviewInfo.llMin && reviewInfo.llMax"> - </span>
                {{ reviewInfo.llMax || reviewInfo.llMin }} Laden Leges
              </span>
            </div>
          </div>
        </div>

        <div class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('Cargo Intention') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <span>
                {{ [...new Set(reviewInfo.selectedCargoes.map(item => item.name))].join(' / ') }}
              </span>
            </div>
          </div>
        </div>

        <div v-if="cargoOrders?.quantityMin || cargoOrders?.quantityMax" class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('Quantity') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              MIN/MAX
              {{ cargoOrders?.quantityMin || cargoOrders?.quantityMax }}
              <span v-if="cargoOrders?.quantityMin || cargoOrders?.quantityMax">-</span>
              {{ cargoOrders?.quantityMax || cargoOrders?.quantityMin }} {{ quantityUnit }}
            </div>
          </div>
        </div>
        <div v-if="cargoOrders?.capacityMin || cargoOrders?.capacityMax" class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('CapacityRequired') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              MIN/MAX {{ cargoOrders?.capacityMin || cargoOrders?.capacityMax }}
              <span v-if="cargoOrders?.capacityMin || cargoOrders?.capacityMax">-</span>
              {{ cargoOrders?.capacityMax || cargoOrders?.capacityMin }} CBM
            </div>
          </div>
        </div>
        <div v-if="cargoOrders?.weightMin || cargoOrders?.weightMax" class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('ActualWeight') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              MIN/MAX {{ cargoOrders?.weightMin || cargoOrders?.weightMax }}
              <span v-if="cargoOrders?.weightMin || cargoOrders?.weightMax">-</span>
              {{ cargoOrders?.weightMax || cargoOrders?.weightMin }} MT
            </div>
          </div>
        </div>
        <div class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('Hire Rate') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <template v-if="reviewInfo?.hireRateSplit && reviewInfo?.hireRateSplitTime && reviewInfo?.hireRateDiot">
                USD {{ reviewInfo?.hireRateSplit }} PD for the 1st {{ reviewInfo?.hireRateSplitTime }} Days Thereafter USD {{ reviewInfo?.hireRateDiot }} DIOT
              </template>
              <template v-else-if="reviewInfo?.hireRateDiot">
                USD {{ reviewInfo?.hireRateDiot }} DIOT
              </template>
              <template v-else>
                Invite Owners Best
              </template>
              <span v-if="reviewInfo?.plusBbLumpsum" class="mg-l-30">
                Plus BB  USD {{ reviewInfo?.plusBbLumpsum }} In Lumpsum
              </span>
            </div>
          </div>
        </div>
        <div class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('Trade Area') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <span v-if="reviewInfo?.tradeRegionLabels">{{ reviewInfo.tradeRegionLabels.split(',').join(' / ') }}</span>
              <span v-if="reviewInfo?.tradeRegionLabels && reviewInfo?.tradeZoneLabels">&nbsp;-&nbsp;</span>
              <span v-if="reviewInfo?.tradeZoneLabels">{{ reviewInfo.tradeZoneLabels.split(',').join(' / ') }}</span>
            </div>
          </div>
        </div>
        <div class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('AddressCommission') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <div>
                {{ cargoOrders.adcom === 'Nil' ? 'Nil' : `${cargoOrders.adcom} %` }}
              </div>
            </div>
          </div>
        </div>

        <div class="flex-al-start flex-jc-bt item">
          <div class="left text-right">
            {{ $L('More Required') }}:
          </div>
          <div class="flex-1">
            <div class="right-content">
              <div>
                <template v-if="reviewInfo.requirements?.swlRequired">
                  Geared&nbsp;<span>{{ reviewInfo.requirements.swlRequired }}</span> MT,&nbsp;
                </template>
                <template v-if="reviewInfo.requirements?.ageMax">
                  Younger than <span>{{ reviewInfo.requirements.ageMax }}</span> Y.O. ,&nbsp;
                </template>
                <template v-if="reviewInfo.requirements?.ageMin">
                  Older than&nbsp;<span>{{ reviewInfo.requirements.ageMin }}</span> Y.O. ,&nbsp;
                </template>
                <template v-if="reviewInfo.requirements?.deckTypeLabels">
                  Deckers in Hold&nbsp;<span>{{ reviewInfo.requirements.deckTypeLabels }}</span> ,&nbsp;
                </template>
                <template v-if="reviewInfo.requirements?.shipHoldLabels">
                  Hold Type&nbsp;<span>{{ reviewInfo.requirements.shipHoldLabels }}</span> ,&nbsp;
                </template>
                <template v-if="reviewInfo.requirements?.cargoTypeLabels">
                  Ship Type(By Cargo)&nbsp;<span>{{ reviewInfo.requirements.cargoTypeLabels }}</span>,&nbsp;
                </template>
                <template v-if="reviewInfo.requirements?.structureTypeLabels">
                  Ship Type(By Structure)&nbsp;<span>{{ reviewInfo.requirements.structureTypeLabels }}</span>,&nbsp;
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer" style="display: block">
        <div class="flex flex-al-end" style="padding: 0 113px">
          <div class="flex-1">
            <SpButton type="primary3" circle-radius="5" height="60" width="150" @click="handleClose">Back</SpButton>
          </div>
          <div>
            <SpButton type="primary" circle-radius="5" height="60" width="150" @click="submit">
              Ok
            </SpButton>
          </div>
        </div>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import SpButton from '../../../common/SpButton'
import { computed, ref, watch } from 'vue'
import { formatDateSection } from '@/utils/convert'
import _forEach from 'lodash/forEach'
import _uniqBy from 'lodash/uniqBy'
import { isArray } from '../../../../utils'
export default {
  name: 'SubmitReview',
  components: { SpButton },
  props: {
    show: Boolean,
    cargoOrders: {
      type: Object,
      default: {}
    },

    quantityUnit: {
      type: String,
      default: 'CBM'
    }
  },

  emits: ['close', 'toSubmit'],

  setup (props, ctx) {
    const reviewInfo = ref({})
    watch(() => props.show, (val) => {
      if (val) {
        const loadingPort = []
        _forEach(Object.keys(props.cargoOrders?.delyPortsSelectedOption), key => {
          if (isArray(props.cargoOrders?.delyPortsSelectedOption[key]) && props.cargoOrders?.delyPortsSelectedOption[key]?.length > 0) {
            loadingPort.push(...props.cargoOrders?.delyPortsSelectedOption[key])
          }
        })
        const dischargingPort = []
        _forEach(Object.keys(props.cargoOrders?.redelPortsSelectedOption), key => {
          if (isArray(props.cargoOrders?.redelPortsSelectedOption[key]) && props.cargoOrders?.redelPortsSelectedOption[key]?.length > 0) {
            dischargingPort.push(...props.cargoOrders?.redelPortsSelectedOption[key])
          }
        })

        let delyTag = null
        if (props.cargoOrders.delyTag.includes('Out of')) {
          delyTag = '1SP'
        } else if (props.cargoOrders.delyTag.includes('TM')) {
          delyTag = 'To make(TM)'
        } else {
          delyTag = props.cargoOrders.delyTag
        }

        let redelTag = null
        if (props.cargoOrders.redelTag.includes('Out of')) {
          redelTag = '1SP'
        } else if (props.cargoOrders.redelTag.includes('TM')) {
          redelTag = 'To make(TM)'
        } else {
          redelTag = props.cargoOrders.redelTag
        }
        reviewInfo.value = {
          chartererAcctCorp: props.cargoOrders?.chartererAcctCorp,
          delyTag,
          loadingPort: loadingPort,
          dischargingPort: dischargingPort,
          redelTag,
          selectedCargoes: props.cargoOrders.selectedCargoes,
          earliestLaycan: props.cargoOrders.earliestLaycan,
          latestLaycan: props.cargoOrders.latestLaycan,
          requirements: props.cargoOrders.requirements,
          adcom: props.cargoOrders.adcom,
          periodFrom: props.cargoOrders.periodFrom,
          periodTo: props.cargoOrders.periodTo,
          periodAbout: props.cargoOrders.periodAbout,
          periodUnit: props.cargoOrders.periodUnit,
          llMin: props.cargoOrders.llMin,
          llMax: props.cargoOrders.llMax,

          // vesselTypes: props.cargoOrders.dwtRequirement.vesselTypes,
          // vesselTypesLables: props.cargoOrders.dwtRequirement.vesselTypesLables,
          // kiloMin: props.cargoOrders.dwtRequirement.kiloMin,
          // kiloMax: props.cargoOrders.dwtRequirement.kiloMax,
          // dwtMin: props.cargoOrders.dwtRequirement.dwtMin,
          // dwtMax: props.cargoOrders.dwtRequirement.dwtMax,
          dwtRequirement: props.cargoOrders.dwtRequirement,

          // viaPortLoad.ports: props.cargoOrders.viaPortLoad.ports,
          firstPortLabels: props.cargoOrders.firstPortLabels,
          viaPortDischarge: props.cargoOrders.viaPortDischarge,
          lastPortLabels: props.cargoOrders.lastPortLabels,

          tradeRegionIds: props.cargoOrders.tradeRegionIds,
          tradeRegionLabels: props.cargoOrders.tradeRegionLabels,
          tradeZoneIds: props.cargoOrders.tradeZoneIds,
          tradeZoneLabels: props.cargoOrders.tradeZoneLabels,
          viaPortLoadLabels: props.cargoOrders.viaPortLoadLabels,
          viaPortDischargeLabels: props.cargoOrders.viaPortDischargeLabels,

          hireRateDiot: props.cargoOrders.hireRateDiot,
          hireRateSplit: props.cargoOrders.hireRateSplit,
          hireRateSplitTime: props.cargoOrders.hireRateSplitTime,

          plusBbLumpsum: props.cargoOrders.plusBbLumpsum
        }
      }
    })
    const handleClose = () => {
      ctx.emit('close')
    }

    // 查看最新的数据
    const submit = () => {
      ctx.emit('toSubmit')
    }

    return {
      reviewInfo,
      formatDateSection,
      handleClose,
      submit
    }
  }
}
</script>

<style scoped lang="less">
.dialog-content {
  color: #000000;
  .drag-item{
    padding: 0 6px;
    margin-right: 10px;
    display: inline-block;
    height: 29px;
    margin-bottom: 4px;
    line-height: 31px;
    background: #FFFFFF;
    border: 1px solid #999999;
    border-radius: 2px;
    cursor: default;
  }
  .list-group {
    .last-label{
      margin-right: 6px;
      margin-left: 4px;
      line-height: 31px;
    }
    .drag-item{
      padding: 0 6px;
      margin-right: 10px;
      display: inline-block;
      height: 29px;
      margin-bottom: 4px;
      line-height: 31px;
      background: #FFFFFF;
      border: 1px solid #999999;
      border-radius: 2px;
      cursor: default;
    }
    .chosen{
      .last-label {
        visibility: hidden;
        //display: none;
      }
    }
  }

  //margin-top: -30px;
  padding: 0 38px;
  .item {
    font-size: 12px;
    margin-bottom: 6px;
    .left {
      line-height: 40px;
      width: 150px;
      padding-right: 10px;
      color: #676767;
    }
    .right-content{
      box-sizing: border-box;
      min-height: 40px; // 68
      background: #F6F6F6;
      text-align: left;
      padding-top: 13px;
      padding-bottom: 13px;
      padding-left: 10px;
      word-break: break-word;
    }
  }
  p {
    margin: 0 0 20px 0;
  }
  .line {
    width: 100%;
    height: 1px;
    border-top: 1px dashed #3A909D;
    opacity: 0.3;
  }

}
</style>
